import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\wamp64\\www\\cyberstone\\components\\About\\Team\\Team.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\wamp64\\www\\cyberstone\\components\\Card\\Card.tsx");
